
<div class="flow-date-time-picker-container">
	<DatePicker
		v-model="innerValue"
		class="flow-date-time-picker"
		:mode="mode"
		:is-range="isRange"
		:popover="popover"
		@input="handleInput"
	>
		<template #default="{ inputValue, togglePopover }">
			<div class="flow-date-time-picker-icon" @click="togglePopover()">
				<Icon
					v-if="mode === 'date' || mode === 'dateTime'"
					name="i-calendar"
					size="small"
					type="filled"
					state="dark"
					:effects="false"
				/>
				<Icon
					v-if="mode === 'time'"
					name="i-clock-fill"
					size="small"
					type="filled"
					state="dark"
					:effects="false"
				/>
			</div>
			<input
				v-if="!isRange"
				:value="inputValue"
				:placeholder="placeholder"
				class="flow-date-time-picker-input"
				readonly
				@click="togglePopover()"
			/>
			<input
				v-if="isRange"
				:value="inputValue.start"
				:placeholder="placeholder"
				class="flow-date-time-picker-input range"
				readonly
				@click="togglePopover()"
			/>
			<Icon v-if="isRange" name="i-arrow-right" type="filled" size="small" :effects="false" />
			<input
				v-if="isRange"
				:value="inputValue.end"
				:placeholder="placeholder"
				class="flow-date-time-picker-input range"
				readonly
				@click="togglePopover()"
			/>
		</template>
	</DatePicker>
</div>
